import React, { Component } from "react";
import NavButton from "components/NavButton";
import { NavLink } from "react-router-dom";
import moment from 'moment';
import capitalise from 'utils/capitalise';


function statusStage(value) {
  switch (value) {
    case 'active': return <div className="status active"><span>Active</span></div>;
    case 'incomplete': return <div className="status incomplete"><span>Incomplete</span></div>;
    case 'discontinued': return <div className="status discontinued"><span>Discontinued</span></div>;
    case 'confirm': return <div className="status confirm-order"><span>Confirm Order</span></div>;
    case 'suspended': return <div className="status suspended"><span>Suspended</span></div>;
  }
}

function regimeItem(size, regime, value){
  if (value) {
    return <li className={size}><span className="regime">{regime + ": "}</span>{value}</li>;
  } else {
    return <li className={size}><span className="regime">{regime + ": "}</span><span className="empty"></span></li>
  }
}

function formatDate(date) {
  if (!date) {
    return "";
  }
  return moment(date).format("DD/MM/YYYY");
}

class PatientBox extends Component {
  render() {

    let patient = {...this.props.patient};
    let adminDose = patient.oldDose && moment(patient.administrationDate).isBefore(moment(patient.shipmentDate), 'd') ? patient.oldDose : patient.orderQuantity;

    return (
      <div className={"patient-box" + ((this.props.type === "loading")?" loading":"")}>
        <div className="patient-details">

          <div className="name">{patient.initials}</div>
          <div className="date">{formatDate(patient.dob)}</div>
          <div className="gender">{capitalise(patient.sex)}</div>
          {statusStage(patient.state)}
        </div>
        <div className={"regime-details " + (patient.state === 'discontinued' || patient.state === 'suspended' ? 'faded' : '')}>
          <ul>
            {regimeItem("double", "site", patient.treatmentSite.name)}
            {regimeItem("single", "role", (patient.userId !== patient.prescriberId)?"Managing":"Prescriber")}
            {regimeItem("single", "additional MyRemedy weekly 8 mg", patient.totalAdditional8mgUnits ? patient.totalAdditional8mgUnits
              + " unit" + (patient.totalAdditional8mgUnits !== 1  ? "s" : "") : "")}
            {regimeItem("double", "next administration", !patient.administrationDate?'':`${formatDate(patient.administrationDate)} - MyRemedy ${adminDose < 64 ? 'Weekly' : 'Monthly'} - ${adminDose}mg`)}
            {regimeItem("double", "next shipment", !patient.shipmentDate?'':`${formatDate(patient.shipmentDate)} - MyRemedy ${patient.orderQuantity < 64 ? 'Weekly' : 'Monthly'} - ${patient.orderQuantity}mg x ${patient.orderQuantity < 64 ? '2' : '1'}`)}
          </ul>

          {/* Implement both - Required for responsive design */}
          <PatientBoxNavigation patient={patient} status={this.props.patient.state} />
        </div>
        <PatientBoxNavigation patient={patient} status={this.props.patient.state} />

        {patient.state === 'confirm' ?
          <div className="patient-box-footer patient-confirm-order">
            <div className="left"><h3>Confirmation for your next order is required!</h3></div>
            <div className="right"><NavButton to={"/myremedy/patients/confirm-order/?patientId=" + patient.id} className="button-type-2">Confirm drug order</NavButton></div>
          </div>
          : ""}

        {patient.isConfirmed ?
          <div className="patient-box-footer patient-confirmed">
            <div className="left">
              <h3>Your next shipment has been confirmed.</h3>
              <p>If you would like to make any modifications please <NavLink to='/myremedy/contact-us'>contact us</NavLink>.</p>
            </div>
          </div>
          : ""}

        {patient.state === 'suspended' ?
          <div className="patient-box-footer patient-suspended">
            <div className="left">
              <h3>As your next shipment was not confirmed this account has been suspended.</h3>
              <p>If you would like to make any modifications please <NavLink to='/myremedy/contact-us'>contact us</NavLink>.</p>
            </div>
          </div>
          : ""}

      </div>
    )
  }
}

class PatientBoxNavigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      additionalMenu: false,
    };
  }

  toggleAdditionalMenu = () => {
    this.setState((prevState) => { return { ...prevState, additionalMenu: !prevState.additionalMenu } });
  }

  render() {

    let totalOrderQuantity = parseInt('' + this.props.patient.totalAdditional8mgUnits) * 8 + parseInt('' + this.props.patient.orderQuantity);
    let isMaxOrderReached = false;
    if (this.props.patient.orderQuantity < 64) {
      if (totalOrderQuantity >= 32) {
        isMaxOrderReached = true;
      }
    } else {
      if (totalOrderQuantity >= 128) {
        isMaxOrderReached = true;
      }
    }


    switch (this.props.status) {
      case "incomplete":
        return (
          <div className="patient-navigation">
            <button className="modify-order button-type-2 text-button">Patient enrolment incomplete</button>
            <span className="additional-settings-wrapper">
              <button className={"additional-settings button-type-2" + (this.state.additionalMenu ? " active" : "")} onClick={() => this.toggleAdditionalMenu()}></button>
              <div className="additional-settings-menu" onMouseLeave={() => this.toggleAdditionalMenu()} style={
                {
                  opacity: ((this.state.additionalMenu) ? "1" : "0"),
                  pointerEvents: ((this.state.additionalMenu) ? "all" : "none"),
                  visibility: ((this.state.additionalMenu) ? "visible" : "hidden"),
                }
              }>
                <ul>
                  <li><NavLink to={"/myremedy/patients/discontinue-patient/?patientId=" + this.props.patient.id}>Discontinue patient</NavLink></li>
                </ul>
              </div>
            </span>
            <NavButton to={"/myremedy/patients/onboarding-enrol-patient/?patientId=" + this.props.patient.id} className="primary-button button-type-2">Continue enrolment</NavButton>
          </div>
        );
      case "discontinued":
      case "suspended":
        return (
          <div className="patient-navigation">
            <button className="modify-order button-type-2 discontinued">Modify order</button>
            <span className="additional-settings-wrapper">
              <button className="additional-settings button-type-2 discontinued"></button>
            </span>
            <span className="additional-myremedy-8mg-wrapper">
              <button className="primary-button button-type-2 discontinued">+ MyRemedy Weekly 8mg</button>
            </span>
          </div>
        );
      default:         
        return (
        <div className="patient-navigation">
          <span className="modify-order-wrapper">
            {(this.props.patient.isConfirmed)?
              <div className="roll-over" data-tooltip="You cannot modify your order after confirmation. Please wait until after you have recieved your current order.">
                <NavButton to={"/myremedy/patients/modify-order/?patientId=" + this.props.patient.id} className={"modify-order button-type-disabled discontinued"}>Modify order</NavButton>
              </div>
            : 
            <NavButton to={"/myremedy/patients/modify-order/?patientId=" + this.props.patient.id} className={"modify-order button-type-2"}>Modify order</NavButton>
            }
          </span>
          <span className="additional-settings-wrapper">
            <button className={"additional-settings button-type-2" + (this.state.additionalMenu ? " active" : "")} onClick={() => this.toggleAdditionalMenu()}></button>
            <div className="additional-settings-menu" onMouseLeave={() => this.toggleAdditionalMenu()} style={
              {
                opacity: ((this.state.additionalMenu) ? "1" : "0"),
                pointerEvents: ((this.state.additionalMenu) ? "all" : "none"),
                visibility: ((this.state.additionalMenu) ? "visible" : "hidden"),
              }
            }>
              <ul>
                <li><NavLink to={"/myremedy/patients/patient-details/?patientId=" + this.props.patient.id}>Patient details</NavLink></li>
                <li><NavLink to={"/myremedy/patients/discontinue-patient/?patientId=" + this.props.patient.id}>Discontinue patient</NavLink></li>
              </ul>
            </div>
          </span>
          <span className="additional-myremedy-8mg-wrapper">
            {((this.props.patient.orderQuantity == 32 || this.props.patient.orderQuantity == 128)?
              <div className="roll-over" data-tooltip="If treating with 32 mg weekly, or 128 mg monthly, you can not request additional MyRemedy Weekly 8 doses."> 
                <NavButton to={"/myremedy/patients/order-extra/?patientId=" + this.props.patient.id} className="primary-button button-type-disabled discontinued">+ MyRemedy Weekly 8mg</NavButton>
              </div>
            :
              (isMaxOrderReached)?
                <div className="roll-over" data-tooltip="You have already ordered your maximum quota of additional MyRemedy Weekly 8 doses for this patient."> 
                  <NavButton to={"/myremedy/patients/order-extra/?patientId=" + this.props.patient.id} className="primary-button button-type-disabled discontinued">+ MyRemedy Weekly 8mg</NavButton>
                </div>
              :
              (
                (this.props.patient.is8mgConfirmed)?
                  <div className="roll-over" data-tooltip="You cannot request additional Weekly 8 doses after 8mg shipment has been confirmed."> 
                    <NavButton to={"/myremedy/patients/order-extra/?patientId=" + this.props.patient.id} className="primary-button button-type-disabled discontinued">+ MyRemedy Weekly 8mg</NavButton>
                  </div>
                  :
                  (!this.props.patient.treatmentSite.allowAdditional)?
                    <div className="roll-over" data-tooltip="The chosen site does not supply additional 8mg doses"> 
                      <NavButton to={"/myremedy/patients/order-extra/?patientId=" + this.props.patient.id} className="primary-button button-type-disabled discontinued">+ MyRemedy Weekly 8mg</NavButton>
                    </div>
                  :
                  <NavButton to={"/myremedy/patients/order-extra/?patientId=" + this.props.patient.id} className="primary-button button-type-2">+ MyRemedy Weekly 8mg</NavButton>
              )
            )
            }
          </span>
        </div>
      );
    }

  }
}

export default PatientBox;

